import React, { FunctionComponent, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { searchUserTenants, switchTenant } from '../../../app/resource/user-tenants/user-tenants.actions';
import { useSelect } from '../../../utils/selector.utils';
import { userTenantsSelectors } from '../../../app/resource/user-tenants/user-tenants.selectors';
import { FaChevronRight } from 'react-icons/fa6';
import { openDialog } from '../../../app/dialog/dialog.actions';
import { Dialogs } from '../../dialogs';

export const WorkspaceSelectionPage: FunctionComponent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(searchUserTenants());
  }, [dispatch]);

  const openWorkspaceCreationDialog = useCallback(() => {
    dispatch(openDialog('workspaceCreationDialog'));
  }, [dispatch]);

  const selectWorkspace = (workspaceId: string) => {
    dispatch(switchTenant(workspaceId));
  };
  const tenants = useSelect(userTenantsSelectors.selectResourceList);

  return (
    <>
      <main id="app-root" className="login">
        <div className="fixed-panel">
          <div className="panel w500">
            <div className="panel-body px-5 pb-0">
              <div className="workspace-selection pb-2">
                <div className="f-4 py-2">Select workspace</div>
                <div className="workspaces-list f-2">
                  {tenants.map((tenant) => (
                    <div
                      key={tenant.id}
                      className="flex justify-between link p-2 border-radius-1"
                      onClick={() => selectWorkspace(tenant.id)}
                    >
                      {tenant.name}
                      <FaChevronRight />
                    </div>
                  ))}
                </div>
                <div className="single-card-container">
                  <div className="panel-body p-0 py-1">
                    <div
                      className="border-radius-1 lightGray-bg p-2 gray-link popup_button"
                      onClick={openWorkspaceCreationDialog}
                    >
                      <div className="new_column flex aic jcc">
                        <span className="small-avatar blueGray-bg mr-1 flex aic jcc">
                          <i className="icon-plus white f-2" />
                        </span>
                        <span className="blueGray">Create new workspace</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Dialogs />
    </>
  );
};
